import React, { useState, useEffect, useRef, useCallback } from "react";

const FoodCategories = {
    "fruits": ["🍎", "🍌", "🍇", "🍉", "🍍", "🥭", "🍊", "🍋", "🍒", "🥝"],
    "vegetables": ["🥕", "🌽", "🥦", "🥒", "🍆", "🧅", "🧄", "🥬", "🍅", "🫑"],
    // "grains": ["🍞", "🥖", "🥨", "🥯", "🍚", "🍙", "🥣"],
    "dairy": ["🥛", "🧀", "🍦", "🍰", "🧁", "🍮", "🧈", "🥚"],
    "meat_seafood": ["🍗", "🥩", "🥓", "🍖", "🦀", "🍤", "🐟", "🍣", "🦞"],
    "snacks": ["🍫", "🍪", "🍩", "🍭", "🍬", "🍿", "🥜", "🥠"],
    "beverages": ["☕", "🍵", "🥤", "🧃", "🍹", "🥂", "🍷", "🍺", "🍾"]
};




function shuffleArray(array: any[]) {
    for (let i = array.length - 1; i > 0; i--) {
        // Generate a random index
        const randomIndex = Math.floor(Math.random() * (i + 1));
        // Swap elements
        [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
    }
    return array;
}

// Question Type
type QuestionType = {
    text: string;
    correctImages: string[];
    allImages: string[];
};



// Dynamic Sizing
const getDynamicSizes = () => {
    const screenWidth = window.innerWidth;
    const imageSize = screenWidth > 1024 ? 90 : screenWidth > 600 ? 100 : 60;
    return { imageSize, minDistance: imageSize * 1.5 };
};

const IdentifyFoodItems = () => {
    const [question, setQuestion] = useState<QuestionType | null>(null);
    const [selectedAnswers, setSelectedAnswers] = useState<{ [key: string]: boolean }>({});
    const [sizes, setSizes] = useState(getDynamicSizes());
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [correctImage, setCorrectImage] = useState<any[]>();
    const [selectedImage, setSelectedImage] = useState('');

    // Generate a question
    const generateRandomQuestion = (remainingImages: number): QuestionType => { 
        const categories = Object.keys(FoodCategories) as (keyof typeof FoodCategories)[];
        const randomCategory = categories[Math.floor(Math.random() * categories.length)];

        const correctPool = FoodCategories[randomCategory];
        const correctImages = shuffleArray(correctPool).slice(0, 3);
        setCorrectImage(correctImages);

        const otherCategories = categories.filter(cat => cat !== randomCategory);
        const otherImagesPool = otherCategories.flatMap(cat => FoodCategories[cat]);
        const uniqueArr = otherImagesPool.filter((value, index, self) => self.indexOf(value) === index).filter(item => !correctImages.includes(item));
        // Ensure enough incorrect images exist
        const incorrectImages = shuffleArray(uniqueArr).slice(0, remainingImages); 
        const allImages = [...correctImages, ...incorrectImages].sort(() => 0.5 - Math.random());

        return {
            text: `Choose 3 ${randomCategory.replace('_', ' ').toLocaleUpperCase()}`,
            correctImages,
            allImages,
        };
    };

    // Memoized function to generate a new question
    const generateQuestion = useCallback(() => { 
        if (!containerRef.current) return;
        //setShowImage(true);
        setTimeout(() => {
            const imageSize = sizes.imageSize;
            const container = containerRef.current?.getBoundingClientRect();
            if (!container) return;

            const columns = Math.floor(container.width / (imageSize + 20)); 
            const rows = Math.floor(container.height / (imageSize + 20)); 
            const totalImage = columns * rows;
            const remainingImages = totalImage > 3 ? totalImage - 3 : 0; // Prevent negative values
            setShowImage(false);
            setQuestion(generateRandomQuestion(remainingImages));
        }, 1000);

    }, [sizes]);

    // Generate a question only once on mount
    useEffect(() => {
        generateQuestion();
        document.title = "Mamas Guidance - Class One - Environment Science - My Needs – Food - Identify Food"; // Set page title
    }, []);



    const handleImageClick = (image: string) => {
        setSelectedImage(image);
        setSelectedAnswers(prev => {
            const newState = { ...prev };
            if (image in newState) {
                delete newState[image];
            } else {
                newState[image] = question?.correctImages.includes(image) ?? false;
            }
            return newState;
        });
    };

    // Check answer and generate new question
    useEffect(() => {
        if (!question) return;

        const selectedCorrectCount = Object.values(selectedAnswers).filter(val => val === true).length; 
        const totalCorrect = question.correctImages.length;
        const allSelected = Object.keys(selectedAnswers).length === totalCorrect; 

        if (selectedCorrectCount === totalCorrect && allSelected) {
            //setShowImage(true);
            setTimeout(() => {
                setSelectedAnswers({});
                setQuestion(null)
                generateQuestion();
                //setShowImage(false);
                setSelectedImage('');

            }, 2000);
        }
    }, [selectedAnswers, question, generateQuestion]);

    return (
        <>
            {showImage ? (
                <div className="contentPart showMiddle">
                    <img style={{ height: "150px" }} className="img-fluid" src={process.env.REACT_APP_LOADING_LINK} alt="Loading" />
                </div>
            ) : (
                <div className="contentPart additionWord chooseImage match-container">
                    <h6 style={{ textAlign: "center" }}>{question?.text}</h6>
                    <div ref={containerRef} className="chooseImageContainer" style={{ position: "relative", width: "100%", height: "100%", justifyContent: "center", alignItems: "center", overflow: "hidden", display: "grid", fontSize: "xxx-large" }}>
                        {question?.allImages.map((img, index) => (
                            <div key={img + index} style={{textAlign:"center", border: `5px solid ${img in selectedAnswers ? (selectedAnswers[img] === true ? "green" : "red") : "transparent"}`}}  onClick={() => handleImageClick(img)}>
                                {img}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default IdentifyFoodItems;
